// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2s7bn","footer":"ReportModalFilter_footer__3vfgy"};